export default "__VITE_PUBLIC_ASSET__cecacef1__"